import { GET_ALLOFFER } from "../const";
import { OfferType } from "../type/Offer.type";

export const getOffer = (data: OfferType) => {
    return {
        type: GET_ALLOFFER,
        payload: data,
    };
};
